import styled from 'styled-components';

export const LinkSection = styled.div`
  &:not(:first-of-type) {
    margin-top: 20px;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${(props) => props.theme['color.greyDark']};
    padding-bottom: 20px;
  }

  > * {
    margin-top: 10px;
  }
`;

export const SectionLabel = styled.div`
  font-size: 18px;
`;
